<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RAmYmL/tc-custom/9781440552656.jpg?1730493388982" alt="This image is the cover for the book Tempestuous, Twisted Lit"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tempestuous, Twisted Lit
      </h1>
      <p class="bookDescription body article font2">
        <p>After a mistake with big financial consequences topples her throne, former "it girl" Miranda Prospero is bitter: she finds herself stranded in a crazed new world, holding court among geeks and misfits at a mall Hot Dog Kabob stand. Then, she gets her chance for revenge. When the storm of the decade snows in the mall workers and last-minute shopaholics for a long winter's night, Miranda sets out to get back at the catty clique who was behind her exile. But there's a complication. She somehow gets handcuffed to sullen loner Caleb. With him (literally) bound to her side, Miranda learns more in one night about her own heart, and human nature, than she ever did as prep royalty. With this twisted take on Shakespeare's <i>The Tempest</i>, authors Kim Askew and Amy Helmes prove again that, from Juliet's grief to Cordelia's rage, no one knew about teen angst better than the Bard. His wisdom holds up nearly half a millennium later.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kim Askew, Amy Helmes
      </h2>
      
      <p class="authorDescription body article">Kim Askew is the author of Anyone But You, a Simon & Schuster book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      S&S Books for Young Readers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e491c44